<template>
  <div class="w-full px-12 py-12">
    <card noRoundedbottom noShadow>
      <template v-slot>
        <div class="flex item-start">
          <div class="flex-1">
            <div class="text-2xl font-bold leading-6 text-pdsPrimaryColor flex-1 mx-2">
              Privacyverklaring Voorschrijfportaal
            </div>
          </div>
        </div>

        <div class="grid my-2">
          <div class="flex items-center px-2">
            <div class="text-lg font-semibold leading-6 text-pdsPrimaryColor">
              Hieronder leest u wat Mediq Nederland B.V. (Mediq) met uw persoonsgegevens doet. Deze privacyverklaring
              geldt specifiek voor het Voorschrijfportaal. Als arts worden er ook persoonsgegevens van u verwerkt in dit
              systeem.
            </div>
          </div>
        </div>
        <div class="grid my-4">
          <div class="flex items-center px-2">
            <div class="text-lg">
              <span class="pt-2 text-bold text-gray-900">Voor welke doelen verwerken we persoonsgegevens?</span>
              <div class="pt-2">
                Om gebruik te maken van het Voorschrijfportaal gebruiken we uw persoonsgegevens voor de volgende
                doeleinden:
                <ul class="list-disc list-inside text-gray-700 space-y-2">
                  <li>Het aanmaken van uw gebruikersaccount</li>
                  <li>Verifiëren dat de bestellingen zijn voorgeschreven door een bevoegde voorschrijver</li>
                  <li>Declaraties bij de zorgverzekeraar van de patiënt te regelen</li>
                  <li>You can request deletion of your data at any time.</li>
                  <li>Hulpmiddelen juist en op tijd afleveren bij de patiënt</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="grid my-4">
          <div class="flex items-center px-2">
            <div>
              <span class="pt-2 text-bold text-lg text-gray-900">Welke persoonsgegevens verwerken we?</span>
              <div class="pt-2 text-bold text-lg text-gray-900">Voor deze dienstverlening verwerken we:</div>
              <ul class="list-disc list-inside text-gray-700 space-y-2">
                <li>Naam</li>
                <li>Geboortedatum</li>
                <li>Geslacht</li>
                <li>Specialisme</li>
                <li>Gebruikersnaam</li>
                <li>Wachtwoord</li>
                <li>Contactgegevens</li>
                <li>Handtekening</li>
                <li>Mediq ID</li>
                <li>BIG nummer of vergelijkbare identifier, zoals een KP nummer of AGB code</li>
              </ul>
            </div>
          </div>
        </div>
        <div class="grid my-4">
          <div class="flex items-center px-2">
            <div>
              <span class="pt-2 text-lg text-bold text-gray-900">Waarom mogen we deze persoonsgegevens verwerken?</span>
              <div class="pt-2 text-gray-700">
                Mediq verwerkt uw persoonsgegevens in het Voorschrijfportaal om ervoor te zorgen dat de
                middelen/zorgprogramma’s die u voorschrijft aan een patiënt op een correcte manier bij de patiënt
                terechtkomen. Het is nodig dat Mediq uw gegevens verwerkt, om te kunnen verifiëren dat de patiënt
                gemachtigd is om deze middelen te ontvangen.
                <div class="pt-2 text-gray-900">
                  Als u geen gebruik meer wilt maken van het Voorschrijfportaal, kunt u contact opnemen via
                  <a href="mailto:info@mediq.com" class="text-blue-600 underline"> info@mediq.com </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="grid my-4">
          <div class="flex items-center px-2">
            <div>
              <span class="pt-2 text-lg text-bold text-gray-900">Hoelang bewaren we uw gegevens?</span>
              <div class="pt-2 text-gray-700">
                We bewaren uw persoonsgegevens net zolang als noodzakelijk is voor de bovenstaande doeleinden. Hierbij
                nemen we de relevante wettelijk gestelde bewaartermijnen in acht. Persoonsgegevens die niet langer nodig
                zijn, verwijderen of anonimiseren we.
                <div class="pt-2 text-gray-700">
                  Datum laatste wijziging van deze privacyverklaring: 18 augustus 2023
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </card>
  </div>
</template>

<script>
export default {
  name: 'Privacy'
};
</script>
